import React from 'react';
import { useTranslation } from 'react-i18next';

const PersonInp = (props) => {
    const {metricId, metricDataId} = props;
    const { t } = useTranslation()
    return (
      <div>
        <div className="displayInlineB updateKREntryDiv">
          <input
            type="text"
            name={`metric[${metricId}][${metricDataId}][val]`}
            className="updateKRProgressEntry"
            placeholder={`${props.placeholderText} ${t('update')}`}
          />
        </div>
      </div>
    );
}

export default PersonInp;